import { z } from 'zod';
export const BrowserDialogSchema = z.object({
    dialogId: z.string(),
    tabId: z.string(),
    type: z.enum(['alert', 'confirm', 'prompt', 'beforeunload']),
    message: z.string().max(20000),
    defaultValue: z.string().max(20000),
});
// Only CSS keywords; never accept remote URLs as cursor images.
export const CursorSchema = z.enum([
    'auto',
    'default',
    'none',
    'context-menu',
    'help',
    'pointer',
    'progress',
    'wait',
    'cell',
    'crosshair',
    'text',
    'vertical-text',
    'alias',
    'copy',
    'move',
    'no-drop',
    'not-allowed',
    'grab',
    'grabbing',
    'all-scroll',
    'col-resize',
    'row-resize',
    'n-resize',
    'e-resize',
    's-resize',
    'w-resize',
    'ne-resize',
    'nw-resize',
    'se-resize',
    'sw-resize',
    'ew-resize',
    'ns-resize',
    'nesw-resize',
    'nwse-resize',
    'zoom-in',
    'zoom-out',
]);
export const NodeUpdateSchema = z.object({
    status: z.enum([
        'idle',
        'checking',
        'available',
        'downloading',
        'downloaded',
        'pending_close',
        'installing',
        'error',
        'disabled',
    ]),
    version: z.string().optional(),
    percent: z.number().optional(),
    error: z.string().optional(),
});
//# sourceMappingURL=browser-tools.js.map